import { Box } from "@mui/system";
import MUIDataTable from "mui-datatables";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function OffBatchCourseComponent({
  setSelectedCourse,
  setprogramfilter,
  setadmissionfilter,
  selectedCourse,
}) {
  let [courses, setCourses] = useState([]);
  let [courseData, setcourseData] = useState([]);
  let [isMounted, setIsMounted] = useState(true);
  let [selectedrows, setselectedrows] = useState([]);

  let { setError } = useContext(CourseAssignmentContext);

  let api = useAxiosPrivate();

  function assignColorForStatus(stat) {
    let color = "white";

    if (stat.trim().toLowerCase() === "active") {
      color = "rgb(66, 207, 66)";
    } else if (stat.trim().toLowerCase() === "in-active") {
      color = "#FF0000";
    }

    return color;
  }

  let columns = [
    {
      name: "Course Name",
      options: {
        filter: false,
      },
    },
    // {
    //     name:"Status",
    //     options:{
    //         filter:false,
    //         customBodyRender:(value,tableMeta,updateValue)=>{
    //             return  (<Box sx={{

    //                   borderColor:'none',

    //                   color:'rgb(234, 234, 234)' ,

    //               }}>
    //               <div style={{
    //                 width:"100%",
    //                 height:"100%",
    //                 backgroundColor :assignColorForStatus(value),
    //                 borderColor:'none',
    //                   borderRadius: "5px",
    //                   padding:"5px 5px",
    //                   textAlign:"center"
    //               }}>
    //               {value}
    //               </div>
    //               </Box>)
    //           }
    //     }
    // },
    {
      name: "Code",
      options: {
        filter: false,
      },
    },
    {
      name: "Cr.Hr",
      options: {
        filter: true,
      },
    },
    {
      name: "LEH",
      options: {
        filter: true,
      },
    },
  ];

  let options = {
    print: "true",
    download: "true",
    filterType: "dropdown",
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    pagination: true,
    responsive: "vertical",
    selectableRows: "single",
    onRowsSelect: (currentRowsSelected, allRowsSelected) => {
      handleSelection(allRowsSelected);
    },
    rowsSelected: selectedrows,
  };

  function handleSelection(selecteddata) {
    let arr = [];
    selecteddata.forEach((row) => {
      arr.push(courseData[row.index]);
      setselectedrows([row.index]);
    });
    // setSelectedCourse(arr)

    if (arr.length > 0) {
      let filtercourse = courses.filter((c) => c.course_code == arr[0][1]);

      setSelectedCourse([filtercourse[0]]);
      setprogramfilter([filtercourse[0].Curriculums[0].program_type]);
      setadmissionfilter([filtercourse[0].Curriculums[0].admission_type]);
    } else {
      setprogramfilter([]);
      setadmissionfilter([]);
      setSelectedCourse([]);
    }
  }
  async function getCourses(signal) {
    try {
      let respdata = await api.get(`courseallocation/offbatchcourses`, {
        signal,
      });
      console.log(respdata.data);

      isMounted && setCourses(respdata.data);
    } catch (err) {
      setError(err.response.data.msg);
    }
  }

  function alignCoursesData() {
    let arr = [];

    courses.forEach((course) => {
      let LEH = course.lab + course.lecture + course.advisory + course.tutorial;
      let arrfordata = [
        course.course_name,
        course.course_code,
        course.credit_hr,

        LEH,
      ];

      arr.push(arrfordata);
    });

    setcourseData(arr);
  }

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getCourses(controller.signal);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  useEffect(() => {
    alignCoursesData();
  }, [courses]);

  useEffect(() => {
    if (selectedCourse.length <= 0) {
      setselectedrows([]);
    }
  }, [selectedCourse]);

  return (
    <div style={{ width: "43%" }}>
      <MUIDataTable
        options={options}
        columns={columns}
        data={courseData}
        title="Course List"
      />
    </div>
  );
}

export default OffBatchCourseComponent;
